import   AttachmentTypeEnum                 from './AttachmentTypeEnum';
import { IAttachment }                      from '.';


/**
 * Define attachment entity associated IMAGE type.
 */
export class AttachmentImageEntity implements IAttachment {
    public attId!: string;
    public type!: AttachmentTypeEnum;

    /**
     * Constructor
     * 
     * @param id - The associated button unique id
     * @param url - The associated source URM
     */
    constructor(private id: string, 
                public url: string) {

                    this.attId = `img-${this.id}`;
                    this.type = AttachmentTypeEnum.IMAGE;
                }
}
